export function getAccountBalanceTemplate(account_balance, type, typeLabelChild) {

  if (typeLabelChild == 'sport'){
    account_balance.type = "sport"
  }else if(typeLabelChild == 'casino'){
    account_balance.type = "casino"
  }else if(typeLabelChild == 'virutal'){
    account_balance.type = "virtual"
  }else {
    account_balance.type == ''
  }
    return `<div class="accountBalanceRow  ${
      role != "User" && account_balance == "sport" ? '' : 'fiveColumnsHolder'}" type="${account_balance.type.toLowerCase()}" user-id="${account_balance.user_id ? account_balance.user_id : account_balance.id}" role="${account_balance.role_name}">
    ${
      role != "User"
        ? `<span class="clickAccountBalance">${account_balance.username}</span>`
        : "<span>*</span>"
    }
    <span> ${
    parseFloat( account_balance.stake ? account_balance.stake : 0).toFixed(2)
  }</span>
    
    <span>${parseFloat( account_balance.win ? account_balance.win : 0).toFixed(2)}</span>
    <span>${account_balance.type.toLowerCase() == "casino" ?  parseFloat( account_balance.jackpot ? account_balance.jackpot : 0).toFixed(2) : "-"}</span>
    
    ${
      role != "User" && account_balance.type.toLowerCase() == "sport"
        ? `<span>${parseFloat(
            account_balance.percentage
              ? account_balance.percentage
              : 0
          ).toFixed(2)}</span>`
        : ""
    }
    
    ${
        role != "User"
            ? `<span>${parseFloat(
            account_balance.difference
                ? account_balance.difference
                : 0
            ).toFixed(2)}</span>`
            : ""
    }
    ${
      role == "User"
          ? `<span>${parseFloat(
          account_balance.difference
              ? account_balance.difference
              : 0
          ).toFixed(2)}</span>`
          : ""
  }
</div>`;
}

export function getSmFinanceTemplate(account_balance,roleName) {
  return `<div class="accountBalanceRow" type="${account_balance.type.toLowerCase()}" user-id="${account_balance.id}" role="${account_balance.role_name}">
   <span class="clickAccountBalance" style="width:16%;">${account_balance.username}</span>
      
  <span style="width:14%;">${
    parseFloat( account_balance.dif_sport ? account_balance.dif_sport : 0).toFixed(2)
  }</span>
  <span style="width:14%;">${
    parseFloat( account_balance.dif_sport_mng ? account_balance.dif_sport_mng : 0).toFixed(2)
  }</span>
  <span style="width:14%;">${
    parseFloat( account_balance.dif_casino ? account_balance.dif_casino : 0).toFixed(2)
  }</span>
  <span style="width:14%;">${
    parseFloat( account_balance.dif_livecasino ? account_balance.dif_livecasino : 0).toFixed(2)
  }</span>
  <span style="width:14%;">${
    parseFloat( account_balance.dif_virtual ? account_balance.dif_virtual : 0).toFixed(2)
  }</span>
  <span style="width:14%;">${
    parseFloat( account_balance.difference ? account_balance.difference : 0).toFixed(2)
  }</span>
</div>`;
}
